import { useEffect } from "react";
import { useState } from "react";
import * as APIModels from "../../../models";
import { Modal, Button } from "react-bootstrap";

export type EmergencyFileModalProps = {
    show: boolean;
    onCancelEmergency: () => void;
    onConfirmEmergency: () => void;
};

export default function EmergencyFileModal({
    show,
    onCancelEmergency,
    onConfirmEmergency,
}: EmergencyFileModalProps) {
    const closeWindow = () => {
        onCancelEmergency();
    };

    const confirm = () => {
        onConfirmEmergency();
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="child-modal-title-vcenter"
            centered
            style={{
                border: "2px solid #000",
            }}
        >
            <Modal.Header>
                <Modal.Title id="child-modal-title-vcenter">
                    Emergency Filing
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row"></div>
                <div className="row">
                    <div className="col-12">
                        You have selected to file this as an Emergency Document.
                        This expedites the filing for an additional fee of
                        $2.99. You agree and authorize eFileMadeEasy to file
                        this document as an Emergency Pleading. Please monitor
                        this pleading closely. If you do not receive
                        confirmation of the filing within 30 minutes you must
                        call eFileMadeEasy at (813) 397-5060.
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    type="button"
                    className="btn-danger"
                    onClick={closeWindow}
                >
                    Cancel
                </Button>
                <Button className="btn-primary " onClick={confirm}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
